module.exports = __webpack_public_path__ + "static/media/montblanc-what-moves-you-makes-you-1.94dcc1b6.jpg";